globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.CKEditor = (function(){

  CKEditor.selector = 'textarea[data-plugin="CKEditor"]';

  if (typeof CKEDITOR !== "undefined") {
    var applyBodyMargin = function(editor) {
      if (editor.elementMode === CKEDITOR.ELEMENT_MODE_REPLACE && editor.document) {
        editor.document.appendStyleText('body{margin:10px;}');
      }
    };
    CKEDITOR.on('instanceReady', function(event) {
      var editor = event.editor;
      applyBodyMargin(editor);
      editor.on('contentDom', function() { applyBodyMargin(editor); });
    });
  }

  CKEditor.init = function($html) {
    $html.find(CKEditor.selector).each(function() {
      var $this = $(this);

      if(CKEDITOR.instances[$this.attr('id')]) {
        CKEDITOR.instances[$this.attr('id')].destroy();
      }

      new CKEditor($this);
    })
  }

  function CKEditor($textarea) {
    this.$textarea = $textarea;
    this.init();
  }

  CKEditor.prototype = {
    init: function(){
      var _this = this;

      var options = {
        startupFocus: false,
        enterMode : CKEDITOR.ENTER_BR,
        height: 80,
        skin: 'moono-lisa',
        extraPlugins: 'autogrow,sourcedialog',
        autoGrow_onStartup: true,
        customConfig: this.$textarea.data("config"),
      };

      if (!this.$textarea.data("keepFont")) {
        options.removePlugins = 'font';
      }

      var palette = this.$textarea.data("palette");
      if (palette) {
        options.colorButton_colors = palette;
        options.colorButton_enableAutomatic = true;
      }

      var editor = CKEDITOR.replace(this.$textarea.attr('id'), options);

      editor.on('key', function() {
        _this.$textarea.val(editor.getData());
        _this.$textarea.trigger('keyup');
      });

      editor.on('change', function() {
        _this.$textarea.val(editor.getData());
        _this.$textarea.trigger('change');
      });
    }
  }

  return CKEditor;

})();
